<div class="d-flex flex-column justify-content-between h-100 chat">
  <div class="chat-content" #scrollingContainer>
    <div class="d-md-none">
      <ng-content></ng-content>
    </div>
    <div class="row mb-2" *ngFor="let message of messages; trackBy: trackByFn">
      <div class="col icon-container">
        <div
          class="icon"
          [ngStyle]="{
            'background-image':
              enumBrokerMessageDirection.TO_BROKER === message.direction && companyLogoUrl ? 'url(' + companyLogoUrl + ')' : ''
          }"
        ></div>
      </div>

      <div class="col">
        <div
          class="message-container p-2"
          [ngClass]="{
            'to-user': enumBrokerMessageDirection.TO_USER === message.direction,
            'to-broker': enumBrokerMessageDirection.TO_BROKER === message.direction,
            'from-ior': enumBrokerMessageDirection.TO_BROKER === message.direction && message.isFromImporterOfRecord
          }"
        >
          <div class="row w-100 mb-2">
            <div class="col-6 message-sender">
              {{ getSenderLabelKey(message) | translate }}
            </div>
            <div class="col-6 message-timestamp">
              {{ message.timestamp | customDateTimeByUtc }}
            </div>
          </div>
          <div class="w-100 message-content">
            {{ message.content }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <form *ngIf="isCanSent" class="chat-footer row pt-2" (ngSubmit)="onSent()">
    <div class="col">
      <app-control-wrapper [control]="formControl" [isShowHelper]="false">
        <textarea
          [formControl]="formControl"
          class="form-control"
          id="messageContent"
          name="messageContent"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'Q*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
          [placeholder]="'FORM_PLACEHOLDER.TYPE_YOUR_MESSAGE_HERE' | translate"
          autofocus
          autocomplete="off"
          [ngStyle]="{ height: textareaHeight + 'px' }"
          (keydown)="sendInputPressKey($event)"
        ></textarea>
      </app-control-wrapper>
      <app-control-wrapper class="duplicate" [control]="formControl" [isShowHelper]="false">
        <textarea
          [formControl]="formControl"
          class="form-control duplicate"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'Q*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
          [placeholder]="'FORM_PLACEHOLDER.TYPE_YOUR_MESSAGE_HERE' | translate"
          autofocus
          autocomplete="off"
          #textareaDuplicate
          [value]="formControl.value"
        ></textarea>
      </app-control-wrapper>
    </div>
    <div class="col btn-sent-container">
      <button type="submit" class="btn btn-primary btn-sent" [disabled]="!formControl.value">{{ "BUTTON.SEND" | translate }}</button>
    </div>
  </form>
</div>
